import * as React from 'react';
import { classNames, validatePropType } from 'uitk-react-utils';
import styles from './uitk-badge.css';
import { UitkBadgeSize, UitkBadgeLoyaltyThemes } from './types.esm.js';

var getClassNameList = classNames.bind(styles);
var UitkBadgeLoyalty = function (props) {
    var _a;
    var text = props.text, size = props.size, theme = props.theme, children = props.children, a11yText = props.a11yText, className = props.className;
    var sharedCssClassName = 'uitk-badge-base';
    var baseCssClassName = 'uitk-badge';
    var loyaltyCssClassName = "".concat(baseCssClassName, "-loyalty");
    var loyaltyBadgeClassNames = getClassNameList(sharedCssClassName, "".concat(sharedCssClassName, "-").concat(validatePropType(size, UitkBadgeSize) ? size : UitkBadgeSize.LARGE), (_a = {}, _a["".concat(sharedCssClassName, "-has-text")] = text, _a), "".concat(loyaltyCssClassName, "-").concat(validatePropType(theme, UitkBadgeLoyaltyThemes) ? theme : UitkBadgeLoyaltyThemes.LOW), className);
    return (React.createElement("span", { className: loyaltyBadgeClassNames },
        children,
        text && (React.createElement("span", { className: getClassNameList("".concat(sharedCssClassName, "-text")), "aria-hidden": !!a11yText }, text)),
        a11yText && React.createElement("span", { className: getClassNameList('is-visually-hidden') }, a11yText)));
};
UitkBadgeLoyalty.displayName = 'UitkBadgeLoyalty';

export { UitkBadgeLoyalty };
